export default "__VITE_ASSET__COEOLsxu__"